
















import { Component, Emit, Vue, Model, Watch, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import VueTagsInput from '@johmun/vue-tags-input';

@Component({
    components: {
        VueTagsInput
    }
})
export default class TagSelector extends Vue {
    // Used to diaplays errors
    @Prop({ default: false }) public showError!: boolean;

    // additional class for wrapping div
    @Prop({ default: '' }) public wrapperClass!: string;

    // Enable/Disable changes
    @Prop({ default: false }) public disabled!: boolean;

    // Used to show custom tag limit error
    private showCustomTagError: boolean = false;

    // Define the model for the v-model. In our case, it will be a CSV string
    @Model('on-model-changed', { type: String, default: '' }) private value!: string;

    // Add our VueX tag store, and bind the store.tags to component.tagList
    @Getter('tags', { namespace: 'tag' })
    private tagList!: Array<{ text: string }>;
    private tagsSelected: Array<{ text: string }> = [];
    private tag: string = '';
    private tagCSV: string = '';
    private placeHolder: string = 'Click to select';

    // Register events our Component can produce
    @Emit()
    public onChanged() {
        return Array<{ text: string }>();
    }

    @Emit()
    public onReady() { return; }

    private mounted() {
        // Since our Component Value is a CSV but the internal vue-tags-input is an object array
        // We will need to set our initial value one time.
        // Normally we could add immediage: true to the watcher, but we don't want to also emit the on-change
        // event the first time. Therefore we check if we have a value and set it internally when we are
        // mounted in Vue
        if (this.value && this.value.length > 0) {
            // Ok we have a value pending so we need to transform it for the vue-tags-input
            const newTags = new Array<{ text: string }>();
            this.value
                .split(',')
                .forEach((tag) => {
                    tag = tag.trim();
                    if (tag.length > 0) {
                        newTags.push({ text: tag });
                    }
                });
            this.tagsSelected = newTags;
            this.placeHolder = newTags.length === 0 ? 'Click to select' : '';
        }
    }

    // Monitor changes to our Model / v-model / value
    @Watch('value')
    private onValueChange(newValue: string) {
        // The newValue should be a CSV
        const newTags = new Array<{ text: string }>();
        if (newValue === undefined) {
            console.log('tagSelector model new value was undefined');
            newValue = '';
        }

        // Split the CSV and add any non-empty tags
        // into the newTags array using the [ { text } ] structure
        newValue
            .split(',')
            .forEach((tag) => {
                tag = tag.trim();
                if (tag.length > 0) {
                    newTags.push({ text: tag });
                }
            });

        // Finally pass the new value into the vue-tags-input via our
        // mapped model
        this.tagsSelected = newTags;
        const newTagCSV = this.getTagsToCSV(newTags);
        if (this.tagCSV !== newTagCSV) {
            // and emit the model changed event
            this.tagCSV = newTagCSV;
            this.$emit('on-model-changed', this.getTagsToCSV(newTags)); // model changed
        }
    }

    // Used to filter the autocomplete list as items are added
    private filteredTags() {
        return this.tagList.filter((i: any) => {
            return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1 && i.text.length > 0;
        });
    }

    // Flatten the tags Array to the CSV string
    private getTagsToCSV(tags: Array<{ text: string }>): string {
        let csv: string = '';
        tags.forEach((t) => {
            if (csv.length === 0) {
                csv = `${t.text}`;
            } else {
                csv += `,${t.text}`;
            }
        });
        return csv;
    }

    // Our event handler for the vue-tags-input on-change event
    private handleTagsChanged(newTags: Array<{ text: string }>) {
        this.placeHolder = newTags.length === 0 ? 'Click to select' : '';
        // validate custom tags
        newTags = this.customTagsValidation(newTags);
        // update internal component value
        this.tagsSelected = newTags;
        // emit our change events
        this.$emit('on-changed', newTags); // array changed
        this.$emit('on-model-changed', this.getTagsToCSV(newTags)); // model changed
    }

    // Validates tags to make sure no more than the allowed limit of custom tags are used.
    // Returns array with valid tags, CUSTOM TAGS over the limit will be removed
    private customTagsValidation(newTags: Array<{ text: string }>): Array<{ text: string }> {
        const customTagLimit: number = 25;
        if (newTags.length <= customTagLimit) {
            return newTags;
        }
        let customTagsCount = 0;
        const validTags: Array<{ text: string }> = [];
        let limitReached: boolean = false;
        const self: any = this;
        newTags.forEach((t) => {
            // check for custom tags
            if (self.tagList.some( (x) => x.text === t.text) ) {
                validTags.push(t);
            } else {
                // if custom tags, add until the max limit is reached
                if (customTagsCount < customTagLimit) {
                    validTags.push(t);
                    customTagsCount++;
                } else {
                    // custom tag limit has been reached
                    limitReached = true;
                }
            }
        });

        // show error for limit reached
        if (limitReached) {
            this.toggleShowCustomTagError();
        }
        return validTags;
    }

    private toggleShowCustomTagError() {
        this.showCustomTagError = true;
        // show error for 5 seconds
        const self = this;
        setTimeout(() => {
            self.showCustomTagError = false;
        }, 5000);
    }
}
